/** Preserve unknown legacy readings instead of treating them as No. */
export function formatGenset(value: string | null | undefined, missing: string): string {
  return value === 'Y' ? 'Yes' : value === 'N' ? 'No' : missing;
}
